import { CustomColumnGridConfig } from '../types'
import dayjs from 'dayjs'
import MeterLink from '@/components/Table/MeterLink'
export const DETAILED_FIELD = 'detailed' as const

const fmtNum = (v: any) => (v === null || v === undefined || v === '') ? '-' : Number(v).toFixed(2)

const detailedColumnsConfig: CustomColumnGridConfig[] = [
  {
    field: 'meterNumber',
    headerName: "מס' מד",
    flex: 1,
    renderCell: (params: any) =>
      params.value != null ? <MeterLink meter={params.value} /> : '-',
    filter: { type: 'search' },
    filterable: true,
  },
  {
    field: 'timestamp',
    headerName: 'תאריך',
    flex: 1,
    filter: { type: 'date' },
    filterable: true,
    sortComparator: (v1, v2) => new Date(v1).getTime() - new Date(v2).getTime(),
    renderCell: (params: any) =>
      params.value ? dayjs(params.value).format('HH:mm DD/MM/YYYY') : '-',
  },
  {
    field: 'dayOfWeek',
    headerName: 'יום',
    flex: 1,
    filter: { type: 'options' },
    filterable: true,
    valueGetter: (_value, row) => {
      const ts = row?.timestamp || row?.date || row?.day
      if (!ts) return ''
      const days = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש']
      return days[dayjs(ts).day()] ?? ''
    },
    sortComparator: (v1: any, v2: any) => {
      const order = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש']
      const idx1 = order.indexOf(String(v1).trim())
      const idx2 = order.indexOf(String(v2).trim())
      return (idx1 === -1 ? 99 : idx1) - (idx2 === -1 ? 99 : idx2)
    },
    renderCell: (params: any) => {
      if (!params.row?.timestamp) return '-'
      const days = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש']
      return days[dayjs(params.row.timestamp).day()]
    },
  },
  {
    field: 'value',
    headerName: 'קריאה',
    flex: 1,
    filter: { type: 'aggregated' },
    filterable: true,
    sortComparator: (v1: any, v2: any) => (Number(v1) || 0) - (Number(v2) || 0),
    renderCell: (params: any) => fmtNum(params.row?.value),
  },
]

export default detailedColumnsConfig
